import { Box, Card, Checkbox, IconButton, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { nodeReferences } from "../../../../../osaway/stores/OsaNodeStore";
import { OsaNode } from "../../../../../osaway/models/OsaNode";
import { useStores } from "../../../../../shared/stores/RootStore";
import { ExpandIcon } from "../../../../../shared/views/icons";
import { NodePhoto } from "../../../../../shared/views/NodePhoto/NodePhoto";

const NodeItemBase = ({
  osaNode,
  index,
  isChecked,
  onCheckboxChange,
  expandPhoto,
}: {
  osaNode: OsaNode;
  index: number;
  isChecked: boolean;
  onCheckboxChange: (
    nodeId: string,
    index: number,
    checked: boolean,
    shiftKey: boolean
  ) => void;
  expandPhoto: () => void;
}) => {
  const { osaNodeStore, mapStore } = useStores();

  const isSelected = osaNode.id === osaNodeStore.getSelected()?.id;
  const nodeReference = nodeReferences.get(osaNode.id)!;

  const selectOsaNode = () => {
    osaNodeStore.select(osaNode.id);
    mapStore.recenterMap();
  };

  const handleCheckboxClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();

    const nextChecked = !isChecked;
    const shiftKey = e.shiftKey === true;

    onCheckboxChange(osaNode.id, index, nextChecked, shiftKey);
  };

  return (
    <Card.Root
      id={osaNode.id}
      flexShrink={0}
      width="240px"
      overflow="hidden"
      outlineStyle="solid"
      outlineWidth={isSelected ? 3 : 0}
      outlineColor={isSelected ? "primary.300" : "transparent"}
    >
      <Stack gap={0}>
        <Box onClick={selectOsaNode}>
          <NodePhoto node={osaNode} />

          <IconButton
            size="sm"
            variant={"ghost"}
            colorPalette="primary"
            onClick={(e) => {
              e.stopPropagation();
              selectOsaNode();
              expandPhoto();
            }}
            aria-label="Open Image"
            position="absolute"
            right={2}
            top={2}
          >
            <ExpandIcon />
          </IconButton>
        </Box>

        <Checkbox.Root
          p={2}
          value={osaNode.id}
          checked={isChecked}
          colorPalette="primary"
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control onClick={handleCheckboxClick} />
          <Checkbox.Label>
            <Text fontSize="xs">
              <Text fontSize="sm" as="span" fontWeight="bold" mr={2}>
                #{nodeReference.index + 1}
              </Text>

              {moment(osaNode.dateTime, "YYYY-MM-DD hh:mm:ss a").format(
                "MM/DD/YYYY HH:mm:ss"
              )}
            </Text>
          </Checkbox.Label>
        </Checkbox.Root>
      </Stack>
    </Card.Root>
  );
};

export const NodeItem = observer(NodeItemBase);
